const LS_KEY = 'permission_status'

export const getLocalPermission = () => {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY)) || {}
  } catch {
    return {}
  }
}

export const setLocalPermission = (data) => {
  localStorage.setItem(LS_KEY, JSON.stringify(data))
}
